import format from "date-fns/format";
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import PlatformIcons from "../../logos/social";
import PublicName from "../../utils/publicName";
import StarRating from "../StarRating";
import "../Review.scss";
import BaseCard from "./BaseCard";

const Card = styled(BaseCard)`
  flex-direction: column;
  text-align: left;
`;

const CardTop = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
`;

const PlatformImg = styled.img`
  width: 24px;
  height: 24px;
  object-fit: contain;
`;

const NameDateWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const AuthorName = styled.span`
  font-weight: 600;
  color: #404040;
  font-size: 0.95em;
`;

const CardDate = styled.span`
  color: #999;
  font-size: 0.82em;
`;

const CommentWrapper = styled.div`
  flex: 1;
  color: #404040;
  font-size: 0.92em;
  line-height: 1.5;
  position: relative;
`;

const ClampedText = styled.div`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${(props) => props.$lines};
  overflow: hidden;
`;

const ReadMoreLink = styled.span`
  position: absolute;
  bottom: 0;
  right: 0;
  background: #f1f1f1;
  padding: 0 0 0 0.3em;
  font-size: inherit;
  line-height: 1.5;

  .fdn-carousel-read-more-ellipsis {
    color: inherit;
  }

  button {
    background: none;
    border: none;
    padding: 0;
    color: #5b9bd5;
    font-size: inherit;
    line-height: inherit;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }
`;

const Recommended = styled.div`
  color: #5b9bd5;
  font-size: 0.9em;
  margin-bottom: 8px;

  i {
    margin-right: 4px;
  }
`;

const CarouselCard = ({ review, onReadMore, lines = 4 }) => {
  const { name, created_at, rating, comment, platform, recommended } = review;
  const platformKey = platform || "FIRST_PARTY";
  const commentRef = useRef(null);
  const [isClamped, setIsClamped] = useState(false);

  useEffect(() => {
    const el = commentRef.current;
    if (el) {
      setIsClamped(el.scrollHeight > el.clientHeight);
    }
  }, [comment, lines]);

  return (
    <Card className="fdn-carousel-card">
      <CardTop className="fdn-carousel-card-top">
        <PlatformImg
          className="fdn-carousel-card-platform-icon"
          src={PlatformIcons[platformKey]}
          alt={platformKey}
        />
        <NameDateWrapper className="fdn-carousel-card-name-date">
          <AuthorName className="fdn-carousel-card-name">
            {name ? PublicName(name) : "Anonymous"}
          </AuthorName>
          <CardDate className="fdn-carousel-card-date">
            {format(created_at, "M/D/YYYY")}
          </CardDate>
        </NameDateWrapper>
      </CardTop>
      {platform === "FACEBOOK" ? (
        recommended ? (
          <Recommended>
            <i className="ion ion-checkmark" /> <span>Recommended</span>
          </Recommended>
        ) : null
      ) : (
        <StarRating rating={rating} className="fdn-rating-card" />
      )}
      <CommentWrapper className="fdn-carousel-card-comment">
        <ClampedText ref={commentRef} $lines={lines}>
          {comment}
          {isClamped && (
            <ReadMoreLink className="fdn-carousel-card fdn-carousel-read-more">
              <span className="fdn-carousel-read-more-ellipsis">… </span>
              <button onClick={() => onReadMore(review)}>read more</button>
            </ReadMoreLink>
          )}
        </ClampedText>
      </CommentWrapper>
    </Card>
  );
};

export default CarouselCard;



// WEBPACK FOOTER //
// ./src/components/carousel/CarouselCard.jsx